import React, { type FunctionComponent } from 'react'
import { BannersList } from 'domains/banners/components/banners-list/BannersList'
import { BannerCreate } from 'domains/banners/components/banner-create/BannerCreate'
import { BannerUpdate } from 'domains/banners/components/banner-update/BannerUpdate'
import { BannerDetails } from 'domains/banners/components/banner-details/BannerDetails'
import { VisibilityConditionsList } from 'domains/banners/components/visibility-conditions-list/VisibilityConditionsList'
import { VisibilityConditionCreate } from 'domains/banners/components/visibility-condition-create/VisibilityConditionCreate'
import { DashSwitch } from 'legacy/dash-components/dash-switch/DashSwitch'
import { DashRoute } from 'legacy/dash-components/dash-route/DashRoute'
import { DashRedirect } from 'legacy/dash-components/dash-redirect/DashRedirect'
import { bannersAdminRoutingConfig } from 'domains/banners/utils/bannersRoutingConfig'

export const BannersAdminSection: FunctionComponent = () => (
  <DashSwitch>
    <DashRoute exact route={bannersAdminRoutingConfig.list} component={BannersList} />
    <DashRoute exact route={bannersAdminRoutingConfig.create} component={BannerCreate} />
    <DashRoute exact route={bannersAdminRoutingConfig.edit} component={BannerUpdate} />
    <DashRoute exact route={bannersAdminRoutingConfig.details} component={BannerDetails} />
    <DashRoute
      exact
      route={bannersAdminRoutingConfig.visibilityConditions}
      component={VisibilityConditionsList}
    />
    <DashRoute
      exact
      route={bannersAdminRoutingConfig.visibilityConditionCreate}
      component={VisibilityConditionCreate}
    />
    <DashRedirect toRoute={bannersAdminRoutingConfig.list} />
  </DashSwitch>
)
